import React, { useState, useEffect } from "react";
import Tippy from "@tippyjs/react";
import Flatpickr from "react-flatpickr";
import InputField from "../../../component/input-field";
import Select from "react-select";
import "../../../css/theme.css";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import PerformanceDateTime from "./PerformanceDateTime";

export const TextField = ({
  index,
  input,
  value,
  allowupdate,
  validation,
  handleChange,
  gridWidthClass,
}) => {
  const { min, max, component_id, label, placeholder, tooltip } =
    input.todo_component;
  const error = `${label} is required field and it cannot be empty`;
  // const error1 = `${label} value should between ${min} and ${max} characters`;
  const error1 = `${label} value should be min ${
    min === null ? "no limit" : min
  } and max ${max === null ? "no limit" : max} `;
  return (
    <div style={{ width: `${gridWidthClass}%` }} className="max-sm:!w-full">
      <InputField
        type="text"
        label={label ? label : "Component Name"}
        placeholder={placeholder ? placeholder : "Component Placeholder"}
        required={input.is_required}
        value={value !== null ? value : ""}
        minlength={min}
        maxlength={max}
        tooltip={tooltip}
        wrapperClass="p-1 w-full"
        onChange={(e) => {
          handleChange(e, input.activity_custom_field_id);
          // setTextValue(e.target.value);
        }}
        error={
          (validation.includes(input.activity_custom_field_id) &&
          input.is_required &&
          (value === null || value === "")
            ? error
            : null) ||
          (validation.includes(input.activity_custom_field_id) &&
          ((min === null ? false : min > value) ||
            (max === null ? false : max < value))
            ? error1
            : null)
        }
        disabled={allowupdate}
      />
    </div>
  );
};

export const NumberField = ({
  index,
  input,
  value,
  allowupdate,
  validation,
  handleChange,
  gridWidthClass,
}) => {
  const { min, max, component_id, label, placeholder, tooltip } =
    input.todo_component;
  const isMandatory = true;
  const error = `${label} is required field and it cannot be empty`;
  // const error1 = `${label} value should between ${min} and ${max} `;
  const error1 = `${label} value should be min ${
    min === null ? "no limit" : min
  } and max ${max === null ? "no limit" : max} `;
  // console.log('validation.includes(input.activity_custom_field_id --', validation.includes(input.activity_custom_field_id))
  return (
    <div style={{ width: `${gridWidthClass}%` }} className="max-sm:!w-full">
      <InputField
        type="number"
        label={label ? label : "Component Name"}
        placeholder={placeholder ? placeholder : "Component Placeholder"}
        required={input.is_required}
        value={value !== null ? value : ""}
        min={min}
        max={max}
        tooltip={tooltip}
        wrapperClass="p-1 w-full"
        onChange={(e) => {
          handleChange(e, input.activity_custom_field_id);
          // setTextValue(e.target.value);
        }}
        error={
          (validation.includes(input.activity_custom_field_id) &&
          input.is_required &&
          !value
            ? error
            : null) ||
          (validation.includes(input.activity_custom_field_id) &&
          ((min === null ? false : min > value) ||
            (max === null ? false : max < value))
            ? error1
            : null)
        }
        disabled={allowupdate}
      />
    </div>
  );
};

export const Paragraph = ({
  index,
  input,
  value,
  allowupdate,
  validation,
  handleChange,
  gridWidthClass,
}) => {
  const { component_id, label, placeholder, tooltip } = input.todo_component;
  const isMandatory = true;
  const error = `${label} is required field and it cannot be empty`;
  return (
    <div style={{ width: `${gridWidthClass}%` }} className="max-sm:!w-full">
      <div className="flex items-center justify-between w-full">
        <label className={`block text-sm font-medium mb-1`}>
          {label ? label : "Component Name"}&nbsp;
          {!input.is_required ? null : <span className="text-rose-500">*</span>}
        </label>
        {!tooltip ? null : (
          <Tippy content={tooltip}>
            <span className="fas fa-info-circle fill-current !text-[--bg-color-500] cursor-pointer text-sm"></span>
          </Tippy>
        )}
      </div>

      <div className="px-1">
        <textarea
          rows="2"
          className={`w-full form-textarea resize-none ${
            allowupdate && "bg-slate-100 text-slate-400 cursor-not-allowed"
          }`}
          placeholder={placeholder ? placeholder : "Component Placeholder"}
          value={value !== null ? value : ""}
          onChange={(e) => {
            handleChange(e, input.activity_custom_field_id);
            // setParagraphValue(e.target.value);
          }}
          disabled={allowupdate}
        ></textarea>
      </div>
      {validation.includes(input.activity_custom_field_id) &&
      input.is_required &&
      (value === null || value === "") ? (
        <div className="text-xs ml-1 text-rose-500">{error}!</div>
      ) : null}
    </div>
  );
};

export const Dropdown = ({
  index,
  input,
  value,
  allowupdate,
  validation,
  handleChange,
  gridWidthClass,
}) => {
  //   const {
  //     componentName,
  //     componentPlaceholder,
  //     componentTooltip,
  //     isMandatory,
  //     dropdownOptions,
  //   } = props;
  const { component_id, label, placeholder, tooltip, list_values } =
    input.todo_component;
  const dropdownOptions = JSON.parse(list_values).map((item) => {
    return {
      label: item,
      value: item,
    };
  });
  const isMandatory = true;
  const error = `${label} is required field and it cannot be empty`;
  return (
    <div className="p-1 max-sm:!w-full" style={{ width: `${gridWidthClass}%` }}>
      <div className="flex items-center justify-between">
        <label className={`block text-sm font-medium mb-1`}>
          {label ? label : "Component Name"}&nbsp;
          {!input.is_required ? null : <span className="text-rose-500">*</span>}
        </label>
        {!tooltip ? null : (
          <Tippy content={tooltip}>
            <span className="fas fa-info-circle fill-current !text-[--bg-color-500] cursor-pointer text-sm"></span>
          </Tippy>
        )}
      </div>

      <div className={`${allowupdate && "cursor-not-allowed"}`}>
        <Select
          options={
            dropdownOptions.filter((element, index) => element?.label).length >
            0
              ? dropdownOptions.filter((element, index) => element?.label)
              : []
          }
          isClearable={true}
          menuPortalTarget={document.body}
          className="unresetText"
          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
            }),
            placeholder: (provided, state) => ({
              ...provided,
              color: "#9B9B9B", // Set your desired color here
              fontSize: "14px",
            }),
          }}
          value={
            value !== null
              ? {
                  label: value,
                  value: value,
                }
              : null
          }
          onChange={(e) => {
            handleChange(e, input.activity_custom_field_id, "dropdown");
            // setDropdownValue(e);
          }}
          placeholder={placeholder ? placeholder : "Component Placeholder"}
          isDisabled={allowupdate}
        />
      </div>
      {validation.includes(input.activity_custom_field_id) &&
      input.is_required &&
      value === null ? (
        <div className="text-xs mt-1 text-rose-500">{error}!</div>
      ) : null}
    </div>
  );
};

export const DateTime = ({
  index,
  input,
  value,
  allowupdate,
  validation,
  handleChange,
  gridWidthClass,
}) => {
  const { component_id, label, placeholder, tooltip, future_date, prior_date } =
    input.todo_component;
  const isMandatory = true;
  const error = `${label} is required field and it cannot be empty`;

  const handleOpen = () => {
    if(!value){
      handleChange([new Date()], input.activity_custom_field_id, "datetime");
    }
  }

  return (
    <div className="p-1 max-sm:!w-full" style={{ width: `${gridWidthClass}%` }}>
      <div className="flex items-center justify-between">
        <label className={`block text-sm font-medium mb-1`}>
          {label ? label : "Component Name"}&nbsp;
          {!input.is_required ? null : <span className="text-rose-500">*</span>}
        </label>
        {!tooltip ? null : (
          <Tippy content={tooltip}>
            <span className="fas fa-info-circle fill-current !text-[--bg-color-500] cursor-pointer text-sm"></span>
          </Tippy>
        )}
      </div>
      {allowupdate ? (
        <div className="relative">
          <InputField
            disabled
            type="text"
            placeholder={placeholder ? placeholder : "Component Placeholder"}
            suffix={<span className="far fa-calendar text-[#1E293B]"></span>}
            value={value ? moment(value).format("YYYY-MM-DD HH:mm") : ""}
          />
        </div>
      ) : (
        <div className="relative">
          <Flatpickr
            data-enable-time
            disabled={false}
            options={{
              altFormat: "j M, Y H:i",
              dateFormat: "Y-m-d H:i",
              time_24hr: true,
              disableMobile: true,
              enableTime: true,
              altInput: true,
              maxDate: !future_date ? moment().format("YYYY-MM-DD HH:mm") : "",
              minDate: !prior_date
                ? moment().startOf("hour").format("YYYY-MM-DD HH:mm")
                : "",
              onOpen: [handleOpen]
            }}
            render={({ defaultValue }, ref) => {
              return (
                <div>
                  <input
                    className={`form-input disabled:border-slate-200 w-full`}
                    defaultValue={defaultValue}
                    ref={ref}
                    placeholder={
                      placeholder ? placeholder : "Component Placeholder"
                    }
                    disabled={false}
                  />
                  <div className="absolute inset-0 left-auto flex items-center opacity-100 group">
                    <span className="text-sm text-slate-500 font-medium px-3">
                      <span className="far fa-calendar text-[#1E293B]"></span>
                    </span>
                  </div>
                </div>
              );
            }}
            value={value !== null ? value : null}
            onChange={(e) => {
              handleChange(e, input.activity_custom_field_id, "datetime");
              // setDateValue(e[0]);
            }}
          />
        </div>
      )}

      {(validation.includes(input.activity_custom_field_id) &&
        input.is_required &&
        value === null) ||
      value === undefined ? (
        <div className="text-xs mt-1 text-rose-500">{error}!</div>
      ) : null}
    </div>
  );
};

export const Checkbox = ({
  index,
  input,
  value,
  allowupdate,
  handleChange,
  gridWidthClass,
}) => {
  const { component_id, label, is_check_by_default } = input.todo_component;
  return (
    <div
      className="flex items-center space-x-3 w-1/2 p-1 my-2"
      style={{ width: `${gridWidthClass}%` }}
    >
      <input
        id="controlPreview"
        type="checkbox"
        name="Advance Control Setting"
        className={`form-checkbox ${
          allowupdate && "!text-slate-400 cursor-not-allowed"
        }`}
        checked={value !== null ? value === "true" : false}
        onChange={(e) => {
          // setCheck(!check);
          handleChange(e, input.activity_custom_field_id, "checkbox");
        }}
        disabled={allowupdate}
      />
      <label
        htmlFor="controlPreview"
        className="text-sm font-medium cursor-pointer"
      >
        {label ? label : "Label"}&nbsp;
        {!input.is_required ? null : <span className="text-rose-500">*</span>}
      </label>
    </div>
  );
};

export const Toggle = ({
  index,
  input,
  value,
  allowupdate,
  handleChange,
  gridWidthClass,
}) => {
  const { component_id, label, is_check_by_default } = input.todo_component;
  return (
    <div
      className="flex items-center space-x-3 w-1/2 p-1 my-2"
      style={{ width: `${gridWidthClass}%` }}
    >
      <div className="form-switch">
        <input
          id="controlSetting"
          type="checkbox"
          name="Advance Control Setting"
          checked={value !== null ? value === "true" : false}
          className={`sr-only`}
          onChange={(e) => {
            // setCheck(!check);
            handleChange(e, input.activity_custom_field_id, "checkbox");
          }}
          disabled={allowupdate}
        />
        <label htmlFor="controlSetting" className="bg-slate-400">
          <span className="bg-white shadow-sm" aria-hidden="true"></span>
        </label>
      </div>
      <h6 className={`text-sm font-medium tracking-tight leading-3`}>
        {label ? label : "Label"}&nbsp;
        {!input.is_required ? null : <span className="text-rose-500">*</span>}
      </h6>
    </div>
  );
};

export const RadioButton = ({
  index,
  input,
  value,
  allowupdate,
  handleChange,
  gridWidthClass,
  validation,
}) => {
  const { list_values, label, is_check_by_default } = input.todo_component;
  const [check, setCheck] = useState();
  const error = `${label} is required field and it cannot be empty`;
  return (
    <div style={{ width: `${gridWidthClass}%` }} className="p-1 max-sm:!w-full">
      <h6
        title={label ? label : "Label"}
        className={`text-sm font-medium tracking-tight leading-3 pb-1 ${
          is_check_by_default && "text-white"
        }`}
      >
        {label ? label : "Label"}&nbsp;
        {!input.is_required ? null : <span className="text-rose-500">*</span>}
      </h6>
      <div className="space-y-1">
        {JSON.parse(list_values)?.map((item, index) => (
          <div key={index} className="flex items-center space-x-3">
            <input
              type="radio"
              id={`option${index}`}
              name="radio-button"
              required={input.is_required}
              className={`h-4 w-4 border-gray-300 form-radio ${
                allowupdate && "!text-slate-400 cursor-not-allowed"
              }`}
              onChange={(e) => {
                handleChange(e, input.activity_custom_field_id);
                setCheck(index);
              }}
              value={item}
              checked={value !== null ? value === item : check === index}
              disabled={allowupdate}
            />
            <label
              htmlFor={`option${index}`}
              className={`text-sm font-medium tracking-tight leading-3 cursor-pointer max-w-2/3 overflow-hidden truncate ${
                is_check_by_default && "text-white"
              }`}
              title={item.label ? item.label : `item ${index + 1}`}
            >
              {item}
            </label>
          </div>
        ))}
        {validation.includes(input.activity_custom_field_id) &&
        input.is_required &&
        (value === null || value === "") ? (
          <div className="text-xs mt-1 text-rose-500">{error}!</div>
        ) : null}
      </div>
    </div>
  );
};

export const Link = ({ index, input, allowupdate, gridWidthClass }) => {
  const { label, tooltip, url } = input.todo_component;
  return (
    <div
      style={{ width: `${gridWidthClass}%` }}
      className="flex items-end space-x-3 p-1 max-sm:!w-full"
    >
      <a
        href={!allowupdate ? url : null}
        target="_blank"
        className={`flex-1 items-end cursor-pointer block space-y-1 ${
          allowupdate && "cursor-not-allowed"
        }`}
        style={allowupdate ? { cursor: "not-allowed" } : {}}
      >
        <div
          className={`bg-white h-9 border first:rounded flex justify-between items-center px-2 w-full ${
            allowupdate && "!bg-slate-100"
          }`}
        >
          <h6
            className={`text-[13px] leading-5 tracking-tight font-semibold text-[--bg-color-500] ${
              allowupdate && "!text-slate-400"
            }`}
          >
            {label ? label : "Component Name"}&nbsp;
            {/* {!isMandatory ? null : <span className="text-rose-500">*</span>} */}
          </h6>
          <div className="block space-x-2">
            {!tooltip ? null : (
              <Tippy content={tooltip}>
                <span className="fas fa-info-circle fill-current !text-[--bg-color-500] cursor-pointer text-sm"></span>
              </Tippy>
            )}
            <span
              className={`fas fa-link text-[--bg-color-500] text-[13px] ${
                allowupdate && "!text-slate-400"
              }`}
            ></span>
          </div>
        </div>
      </a>
    </div>
    // <div className="flex-1 cursor-pointer space-y-1">
    //   <div className="bg-white h-9 border first:rounded flex justify-between items-center px-2">
    //     <h6 className="text-[13px] leading-5 tracking-tight font-semibold text-[--bg-color-500]">
    //       {label ? label : "Component Name"}&nbsp;
    //       {/* {!isMandatory ? null : <span className="text-rose-500">*</span>} */}
    //     </h6>
    //     <a href={link_url} target="_blank" className="block space-x-2">
    //       {!tooltip ? null : (
    //         <Tippy content={tooltip}>
    //           <span className="fas fa-info-circle fill-current text-[--bg-color-500] cursor-pointer text-sm"></span>
    //         </Tippy>
    //       )}
    //       <span className="fas fa-link text-[--bg-color-500] text-[13px]"></span>
    //     </a>
    //   </div>
    // </div>
  );
};
